import { render, staticRenderFns } from "./entrance.vue?vue&type=template&id=bf9aed2e&scoped=true&"
import script from "./entrance.vue?vue&type=script&lang=js&"
export * from "./entrance.vue?vue&type=script&lang=js&"
import style0 from "./entrance.vue?vue&type=style&index=0&id=bf9aed2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9aed2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf9aed2e')) {
      api.createRecord('bf9aed2e', component.options)
    } else {
      api.reload('bf9aed2e', component.options)
    }
    module.hot.accept("./entrance.vue?vue&type=template&id=bf9aed2e&scoped=true&", function () {
      api.rerender('bf9aed2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/subrole/components/entrance.vue"
export default component.exports